<template>
  <v-card :elevation="6" class="mx-auto pa-6 ml-2" >
    <grafico-barras
    :title="$tc('label.dash_orcamento_oi', 1)"
    :chart-title="$tc('label.dash_orcamento_oi', 1)"
    idGrafico="orcamento_oi"
    category-field="descricao"
    :qtdColunasLegenda="qtdColunasLegenda"
    :value-fields="valueFields"
    :dados="dados"
    :colors="colors"
    titleRodape="OI"
    :unit-y-axis="`${$t('label.unidade_dinheiro')} `"/>
  </v-card>
</template>
<script>

import { buscarDadosGraficoOrcamentoPorOi } from '../../../../common/resources/akzo-dashboard-sustentabilidade';
import GraficoBarras from '../../graficos/GraficoBarras';

export default {
  name: 'GraficoBarrasOrcamentoPorOi',
  props: {
    filtro: {
      type: Object,
    },
  },
  watch: {
    filtro: {
      handler() {
        this.filtroAplicado = this.filtro;
        this.buscarDadosGrafico();
      },
    },
  },
  computed: {
    filtrosFixosClass() {
    },
    isDadosGrafico() {
      return this.dados && this.dados.length > 0;
    },
  },
  components: {
    GraficoBarras,
  },
  data() {
    return {
      dados: [],
      valueFields: [],
      listValueFields: [
        'planejado',
        'investido',
      ],
      qtdColunasLegenda: 0,
      loading: false,
      filtroAplicado: this.filtro,
      colors: ['#4285f4', '#ff9901'],
    };
  },
  methods: {
    buscarDadosGrafico() {
      buscarDadosGraficoOrcamentoPorOi(this.filtroAplicado, this.$resource)
        .then((response) => {
          this.dados = response.data.dados;
          this.qtdColunasLegenda = this.valueFields.length;
          this.valueFields = this.listValueFields.map((v) => {
            const item = {
              balloonText: `${this.getLabel(v)} : ${this.$t('label.unidade_dinheiro')} [[value]]`,
              title: v === 'planejado' ? this.$tc('label.dash_vlr_planejado_orcamento_oi', 1) : this.$tc('label.dash_vlr_investido_orcamento_oi', 1),
              valueField: v,
              type: 'column',
            };
            return item;
          });
        }).catch((err) => {
          this.$error(this, err);
        });
    },
    capitalize(str) {
      if (typeof str !== 'string') {
        return '';
      }
      return str.charAt(0).toUpperCase() + str.substr(1);
    },
    getLabel(v) {
      return this.capitalize(v);
    },
  },
};
</script>
